import {zh} from "../../__snowpack__/pkg/genie-i18n-erp.js";
export default zh;
